export default "__VITE_ASSET__C3Sv_Qq___"